import React from 'react'
import styles from './Main.module.scss'
import InitialPage from '../../components/initialPage/InitialPage'
import AboutMe from '../../components/AboutMe/AboutMe'
import Certificates from '../../components/Certificates/Certificates'
import Criteria from '../../components/Criteria/Criteria'
import Numbers from '../../components/Numbers/Numbers'

const Main = ({isImageOpen, isOpen, isRus, isCareerOpen}) => {

    return (
        <section className={styles.main}>
            <InitialPage
                isOpen={isOpen}
                isRus={isRus}
            />
            <Numbers
                isRus={isRus}
            />
            <AboutMe
            isRus={isRus}
            isCareerOpen={isCareerOpen}
            />
            <Certificates
            isImageOpen={isImageOpen}
            isRus={isRus}
            />
            <Criteria
                isRus={isRus}
            />
        </section>
    )
}

export default Main